import Actions from '.';
import { get, post, put ,deleteCall} from '../../../utils/api';
import { API_ERROR_MESSAGE } from '../../../constants';

const getBanners = (screen) => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await get(`banners?screen=${screen}`);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                list: data.response || [],
            }));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
                list: [],
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loadingData: false,
            error: e.message || API_ERROR_MESSAGE,
            list: []
        }));
    }
});

const addBanner = values => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const { bannerImage, title, screen, categoryId, subcategoryId } = values
        const body = new FormData();
        body.append('title', title);
        body.append('screen', screen);
        body.append('subcategoryId', subcategoryId);
        body.append('categoryId', categoryId);
        body.append('bannerImage', bannerImage);
        const data = await post(`banners`, body, { contentType: 'multipart/form-data' });
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message,
                showModal: false,
            }));
            dispatch(getBanners(screen));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }
});

const editBanner = values => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const { bannerImage, title, screen, categoryId, subcategoryId, id } = values
        const body = new FormData();
        body.append('title', title);
        body.append('screen', screen);
        body.append('subcategoryId', subcategoryId);
        body.append('categoryId', categoryId);
        if (typeof bannerImage !== 'string') body.append('bannerImage', bannerImage);
        const data = await put(`banners/${id}`, body, { contentType: 'multipart/form-data' });
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message,
                showModal: false,
            }));
            dispatch(getBanners(screen));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }
});

const deleteBanner = (id,screen) => (async (dispatch) => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await deleteCall(`banners/${id}`);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message,
                success: true,
            }));
            dispatch(getBanners(screen));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
                data: [],
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
            data: [],
        }));
    }
});

export default {
    getBanners,
    addBanner,
    editBanner,
    deleteBanner
}